import {ReportFileFiltersType} from "../hooks/useWmsReportFileQuery";

export const ReportFileInitialValue: ReportFileFiltersType = {
    type: undefined,
    name: undefined,
    // 默认日期不写入 URL/hash：由页面/筛选组件在运行时展示“最近一周”
    reportDate: undefined,
    operatorId: undefined,
}; 